export const LANGUAGES = [
  {
    value: 'applescript',
    label: 'AppleScript',
    extension: '.applescript',
  },
  {
    value: 'asm6502',
    label: 'Assembly',
    extension: '.asm',
  },
  { value: 'bison', label: 'Bison', extension: '.bison' },
  { value: 'c', label: 'C', extension: '.c' },
  { value: 'csharp', label: 'C#', extension: '.cs' },
  { value: 'cpp', label: 'C++', extension: '.cpp' },
  { value: 'css', label: 'CSS', extension: '.css' },
  { value: 'clojure', label: 'Clojure', extension: '.clj' },
  {
    value: 'coffeescript',
    label: 'CoffeeScript',
    extension: '.coffee',
  },
  { value: 'dart', label: 'Dart', extension: '.dart' },
  {
    value: 'django',
    label: 'Django/Jinja2',
    extension: '.jinja',
  },
  {
    value: 'docker',
    label: 'Docker',
    extension: '.dockerfile',
  },
  { value: 'flow', label: 'Flow', extension: '.flow' },
  { value: 'fortran', label: 'Fortran', extension: '.f90' },
  { value: 'fsharp', label: 'F#', extension: '.fs' },
  {
    value: 'graphql',
    label: 'GraphQL',
    extension: '.graphql',
  },
  { value: 'git', label: 'Git', extension: '.git' },
  { value: 'ejs', label: 'EJS', extension: '.ejs' },
  { value: 'elixir', label: 'Elixir', extension: '.ex' },
  { value: 'erlang', label: 'Erlang', extension: '.erl' },
  { value: 'eiffel', label: 'Eiffel', extension: '.e' },
  { value: 'go', label: 'Go', extension: '.go' },
  {
    value: 'groovy',
    label: 'Groovy',
    extension: '.groovy',
  },
  { value: 'haskell', label: 'Haskell', extension: '.hs' },
  { value: 'html', label: 'HTML', extension: '.html' },
  { value: 'java', label: 'Java', extension: '.java' },
  { value: 'json', label: 'JSON', extension: '.json' },
  { value: 'julia', label: 'Julia', extension: '.jl' },
  { value: 'jsx', label: 'React JSX', extension: '.jsx' },
  {
    value: 'javascript',
    label: 'JavaScript',
    extension: '.js',
  },
  { value: 'kotlin', label: 'Kotlin', extension: '.kt' },
  { value: 'less', label: 'Less', extension: '.less' },
  { value: 'textfile', label: 'Logo', extension: '.txt' },
  {
    value: 'markdown',
    label: 'Markdown',
    extension: '.md',
  },
  {
    value: 'textfile',
    label: 'Machine Code',
    extension: '.txt',
  },
  {
    value: 'makefile',
    label: 'Makefile',
    extension: '.mak',
  },
  {
    value: 'matlab',
    label: 'MatLab',
    extension: '.matlab',
  },
  { value: 'nginx', label: 'NGINX', extension: '.nginx' },
  { value: 'ocaml', label: 'OCaml', extension: '.ml' },
  {
    value: 'objectivec',
    label: 'Objective-C',
    extension: '.m',
  },
  { value: 'pascal', label: 'Pascal', extension: '.pas' },
  { value: 'perl', label: 'Perl', extension: '.pl' },
  { value: 'php', label: 'PHP', extension: '.php' },
  { value: 'python', label: 'Python', extension: '.py' },
  {
    value: 'powershell',
    label: 'PowerShell',
    extension: '.ps1',
  },
  { value: 'r', label: 'R', extension: '.r' },
  { value: 'ruby', label: 'Ruby', extension: '.rb' },
  { value: 'rust', label: 'Rust', extension: '.rs' },
  { value: 'sass', label: 'Sass', extension: '.sass' },
  { value: 'scala', label: 'Scala', extension: '.scala' },
  { value: 'scheme', label: 'Scheme', extension: '.scm' },
  { value: 'scss', label: 'SCSS', extension: '.scss' },
  { value: 'swift', label: 'Swift', extension: '.swift' },
  {
    value: 'javascript',
    label: 'Scratch',
    extension: '.js',
  },
  {
    value: 'smalltalk',
    label: 'Smalltalk',
    extension: '.st',
  },
  { value: 'tcl', label: 'Tcl', extension: '.tcl' },
  {
    value: 'typescript',
    label: 'TypeScript',
    extension: '.ts',
  },
  { value: 'tsx', label: 'React TSX', extension: '.tsx' },
  { value: 'vim', label: 'vim', extension: '.vim' },
  {
    value: 'visual-basic',
    label: 'Visual Basic',
    extension: '.vb',
  },
  { value: 'yaml', label: 'YAML', extension: '.yaml' },
];

export const SEARCHFILTERS = [
  { value: 'title', label: 'Title' },
  { value: 'language', label: 'Language' },
  { value: 'tag', label: 'Tags' },
];
